import knowledgeBaseSubscriptions from "../../api/controllers/knowledgeBase/subscriptions"
import notificationController from "../../api/controllers/notification"

export const approveNewsAfterArticleDelete = async (projectId: string, articleSymbolCode: string) => {
    const users = await knowledgeBaseSubscriptions.getArticleSubscribers(projectId, articleSymbolCode)

    await notificationController.approveNewsByUsersLogin(users, articleSymbolCode)
}
